import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Services() {
  const [customer, setCustomer] = useState([]);
  const [vendor, setVendor] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/categories?type=customer")
      .then((r) => setCustomer(r.data))
      .catch(() => {});

    api
      .get("/categories?type=vendor")
      .then((r) => setVendor(r.data))
      .catch(() => {});
  }, []);

  const Grid = ({ items, type }) => (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {items.map((c) => (
        <button
          key={c.id}
          onClick={() => navigate(`/file-complaint?as=${type}`)}
          data-testid={`service-cat-${c.id}`}
          className="rounded-xl border border-slate-200 bg-white p-4 text-left hover:border-teal-brand/40"
        >
          <p className="font-medium text-slate-800 text-sm">
            {c.name}
          </p>
          <p className="text-xs text-teal mt-1">
            File a complaint
          </p>
        </button>
      ))}
    </div>
  );

  return (
    <div>
      <Seo
        title="Consumer Complaint Services & Dispute Resolution | ComplaintAdvisor"
        description="Explore consumer complaint services for documenting disputes, communicating with customers or vendors, and working toward resolution through ComplaintAdvisor."
        path="/consumer-services"
      />

      <div className="ca-container py-12">
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">
          Consumer Complaint Services
        </h1>

        <p className="text-slate-600 mt-2 max-w-2xl">
          Choose a category to document a dispute.
        </p>

        <div className="mt-8">
          <Tabs defaultValue="customer">
            <TabsList>
              <TabsTrigger
                value="customer"
                data-testid="tab-customer-services"
              >
                Customer Services
              </TabsTrigger>

              <TabsTrigger
                value="vendor"
                data-testid="tab-vendor-services"
              >
                Vendor Services
              </TabsTrigger>
            </TabsList>

            <TabsContent value="customer" className="mt-6">
              <Grid items={customer} type="customer" />
            </TabsContent>

            <TabsContent value="vendor" className="mt-6">
              <Grid items={vendor} type="vendor" />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}